/**
 * local save
 */

export class StoreLocalFactory{
    constructor(Cls){
        this.store = Cls || window.localStorage;
    }
    save(key, data){
        this.store.setItem(key, typeof data === 'object'?
         JSON.stringify(data) : data);
    }
    get(key){
        let data = this.store.getItem(key);
        if(data && typeof data ==='string' && /^(\{|\[).*(\}|\])$/.test(data)){
           data = JSON.parse(data);
        }
        return data;
    }
    remove(key){
        this.store.removeItem(key);
    }
}

export const storeLocal = new  StoreLocalFactory();